import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type MoreDotsProps = {
    className?: string;
};

const MoreDots: FunctionComponent<MoreDotsProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'more-dots'}
            viewBox="0 0 250 250"
        >
            <path d="M33 158.2C15.1 158.2.5 143.6.5 125.7S15.1 93.2 33 93.2s32.5 14.6 32.5 32.5-14.6 32.5-32.5 32.5zm0-56c-13 0-23.5 10.5-23.5 23.5S20 149.2 33 149.2s23.5-10.5 23.5-23.5S46 102.2 33 102.2z" />
            <path d="M125 158.2c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5 32.5 14.6 32.5 32.5-14.6 32.5-32.5 32.5zm0-56c-13 0-23.5 10.5-23.5 23.5s10.5 23.5 23.5 23.5 23.5-10.5 23.5-23.5-10.5-23.5-23.5-23.5z" />
            <path d="M217 158.2c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5 32.5 14.6 32.5 32.5-14.6 32.5-32.5 32.5zm0-56c-13 0-23.5 10.5-23.5 23.5s10.5 23.5 23.5 23.5 23.5-10.5 23.5-23.5-10.5-23.5-23.5-23.5z" />
        </svg>
    );
};
export default MoreDots;
